import { createSlice } from "@reduxjs/toolkit";
import {
  deleteHotelAdmin,
  deleteUndoHotelAdmin,
  fetchHotelAdmin,
  updateHotelAdmin,
} from "./adminThunks";

const initialState = {
  data: [],
  totalPages: 1,
  totalItems: 0,
  loading: false,
  error: null,
};

const hotelAdminSlice = createSlice({
  name: "hotelAdmin",
  initialState,

  extraReducers: (builder) => {
    builder
      // get All Hotel Admin
      .addCase(fetchHotelAdmin.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchHotelAdmin.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
        state.totalPages = action.payload.totalPages;
        state.totalItems = action.payload.totalItems;
      })
      .addCase(fetchHotelAdmin.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateHotelAdmin.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateHotelAdmin.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.data.findIndex(
          (item) => item._id === action.payload.id
        );
        console.log(action.payload.data);
        if (index !== -1) {
          state.data[index] = action.payload.data;
        }
      })
      .addCase(updateHotelAdmin.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Delete Hotel Amenities
      .addCase(deleteHotelAdmin.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteHotelAdmin.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.data.findIndex(
          (item) => item._id === action.payload
        );
        if (index !== -1) {
          state.data[index].status = "deleted";
        }
      })
      .addCase(deleteHotelAdmin.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteUndoHotelAdmin.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteUndoHotelAdmin.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.data.findIndex(
          (item) => item._id === action.payload
        );
        if (index !== -1) {
          state.data[index].status = "activate";
        }
      })
      .addCase(deleteUndoHotelAdmin.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default hotelAdminSlice.reducer;
